import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Server status helpers
export const OFFLINE_THRESHOLD_SECONDS = 90; // mark offline if last_seen is older than this (90 seconds = 1.5x heartbeat)

export type ServerStatus = 'online' | 'offline' | 'warning' | 'critical';

export function computeEffectiveStatus(status: string, last_seen?: string | null): ServerStatus {
  if (!last_seen) return 'offline';
  const last = new Date(last_seen).getTime();
  if (Number.isNaN(last)) return 'offline';
  return (Date.now() - last > OFFLINE_THRESHOLD_SECONDS * 1000) ? 'offline' : (status as ServerStatus);
}

export function secondsSince(date?: string | null): number | null {
  if (!date) return null;
  const t = new Date(date).getTime();
  if (Number.isNaN(t)) return null;
  return Math.floor((Date.now() - t) / 1000);
}
